import React, { useState, useRef } from 'react';

import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Dropdown } from 'primereact/dropdown';
import { Growl } from 'primereact/growl';

import instanciaAxios from '../../servicios/InterceptorAxios';
import { esObjetoVacio } from '../../servicios/ServicioObjetos';

export const FomularioReceptor = (props) => {
    const { receptor, setReceptor, erroresForm, urlConsultaUsoCfdi,
        urlConsultaRegimen } = props;
    const [regimenes, setRegimenes] = useState([]);
    const [usosCfdi, setUsosCfdi] = useState([]);
    let growl = useRef(null);

    const handleChange = (e, mayusculas) => {
        const { name, value } = e.target;
        let elValor = value;
        if (mayusculas) {
            if (elValor && typeof elValor !== 'object')
                elValor = elValor.toUpperCase();
        }
        setReceptor(valoresPrevios => ({
            ...valoresPrevios,
            [name]: elValor
        }));
    };

    const buscarReceptorPorRfc = () => {
        if (!esObjetoVacio(receptor.rfc) && (receptor.rfc.length === 12 || receptor.rfc.length === 13)) {
            setReceptor(valoresPrevios => ({
                ...valoresPrevios,
                ['regimenFiscal']: null,
                ['usoCfdi']: null
            }));
            instanciaAxios.post(urlConsultaRegimen, { rfc: receptor.rfc }).then(response => {
                setRegimenes(response.data);
            }).catch(error => {

            });
        }
    }

    const muestramensajecorreos = () => {
        growl.current.show({ life: 8000, severity: 'info', summary: 'Información', detail: 'Ingresa más correos, solo separalos por una coma "," Ejemplo:(correouno,correodos)' });
    }

    const customTemplate = (option) => {
        return <div><strong>{option.id}</strong> - <strong>{option.descripcion}</strong></div>;
    }

    const cambioRegimen = (event) => {
        let elValor = event.value;
        setReceptor(valoresPrevios => ({
            ...valoresPrevios,
            ['regimenFiscal']: elValor,
            ['usoCfdi']: null
        }));
        instanciaAxios.post(urlConsultaUsoCfdi, { rfc: receptor.rfc, regimenFiscal: elValor.id }).then(response => {
            setUsosCfdi(response.data);
        }).catch(error => {

        });
    }


    return (
        <div>
            <Growl ref={growl} />
            <div className="card card-w-title">
                <h1>Datos fiscales</h1>
                <div className="p-grid">
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="rfc">* Rfc</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="rfc" name="rfc" value={receptor.rfc || ''}
                            onChange={(e) => handleChange(e, true)} className={erroresForm.rfc ? 'p-error' : ''}
                            placeholder="Rfc" onBlur={buscarReceptorPorRfc} />
                        {erroresForm.rfc ? <div><br /> <Message severity="error" text={erroresForm.rfc} /> </div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="nombre">Nombre o Razón Social</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="nombre" name="nombre" value={receptor.nombre || ''}
                            onChange={(e) => handleChange(e, true)} className={erroresForm.nombre ? 'p-error' : ''}
                            placeholder="Nombre o Razón Social" />
                        {erroresForm.nombre ? <div><br /> <Message severity="error" text={erroresForm.nombre} /> </div> : null}
                    </div>

                    <div className="p-col-12 p-md-2">
                        <label htmlFor="domiciliFicalReceptor">* Domicilio Fiscal Receptor (Código postal)</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="domicilioFiscalReceptor" name="domicilioFiscalReceptor"
                             value={receptor.domicilioFiscalReceptor || ''} onChange={(e) => handleChange(e, true)}
                            className={erroresForm.domicilioFiscalReceptor ? 'p-error' : ''}
                            placeholder="Domicilio Fiscal Receptor (Código postal)"  maxLength="5" />
                        {erroresForm.domicilioFiscalReceptor ? <div><br /> <Message severity="error" text={erroresForm.domicilioFiscalReceptor} /> </div> : null}
                    </div>

                    <div className="p-col-12 p-md-2">
                        <label htmlFor="regimenFiscal">* Regimen Fiscal</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <Dropdown dataKey="id" id="regimenFiscal" name="regimenFiscal" options={regimenes}
                            value={receptor.regimenFiscal} onChange={cambioRegimen}
                            itemTemplate={customTemplate} optionLabel="descripcion"
                            className={erroresForm.regimenFiscal ? 'p-error' : ''} />
                        {erroresForm.regimenFiscal ? <div><br /> <Message severity="error" text={erroresForm.regimenFiscal} /> </div> : null}
                    </div>

                    <div className="p-col-12 p-md-2">
                        <label htmlFor="usoCfdi">* Uso del Cfdi</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <Dropdown dataKey="id" id="usoCfdi" name="usoCfdi" options={usosCfdi}
                            value={receptor.usoCfdi} onChange={handleChange} itemTemplate={customTemplate}
                            optionLabel="descripcion" className={erroresForm.usoCfdi ? 'p-error' : ''} />
                        {erroresForm.usoCfdi ? <div><br /> <Message severity="error" text={erroresForm.usoCfdi} /> </div> : null}
                    </div>

                    
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="correo">* Correo</label>
                        </div>
                        <div className="p-col-12 p-md-4">
                            <InputText id="correo" name="correo" value={receptor.correo || ''}
                                onChange={handleChange} className={erroresForm.correo ? 'p-error' : ''}
                                placeholder="Correo electrónico" onFocus={muestramensajecorreos} />
                            {erroresForm.correo ? <div><br /> <Message severity="error" text={erroresForm.correo} /> </div> : null}
                        </div>
                   


                </div>
            </div>
        </div>
    );
}